import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// attach admin JWT (if present) to every request
api.interceptors.request.use((config) => {
  const tk = localStorage.getItem("velmonte_token");
  if (tk) config.headers.Authorization = `Bearer ${tk}`;
  return config;
});

export const WHATSAPP_NUMBER = "34645459043";

export function buildWhatsAppLink(payload) {
  const lines = [
    "VELMONTÉ — New Request",
    payload.name ? `Name: ${payload.name}` : null,
    payload.category ? `Service: ${payload.category}` : null,
    payload.urgency ? `Urgency: ${payload.urgency}` : null,
    payload.location ? `Location: ${payload.location}` : null,
    payload.date ? `Date: ${payload.date}` : null,
    payload.phone ? `Phone: ${payload.phone}` : null,
    payload.email ? `Email: ${payload.email}` : null,
    "",
    payload.message || "",
  ].filter((l) => l !== null);
  const text = encodeURIComponent(lines.join("\n"));
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
}

export function whatsAppSimple(prefill) {
  const text = encodeURIComponent(prefill || "VELMONTÉ — I would like to speak to my concierge.");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
}

export async function createRequest(payload) {
  const { data } = await api.post("/requests", payload);
  return data;
}

export async function listRequests() {
  const { data } = await api.get("/requests");
  return data;
}

export async function updateRequest(id, patch) {
  const { data } = await api.patch(`/requests/${id}`, patch);
  return data;
}

export async function deleteRequest(id) {
  const { data } = await api.delete(`/requests/${id}`);
  return data;
}

export async function getStats() {
  const { data } = await api.get("/admin/stats");
  return data;
}

export async function seedDemo() {
  const { data } = await api.post("/admin/seed");
  return data;
}

export async function adminLogin(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
}

export async function adminMe() {
  const { data } = await api.get("/auth/me");
  return data;
}
